import { styled } from "@vitality-ds/system";
import { BaseAdornmentWrapperStyles } from "./styles/BaseAdornmentWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseAdornmentWrapper = styled("div", BaseAdornmentWrapperStyles);